/**
 * @generated SignedSource<<3b3529795fd904812c32e34a4163276b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsGrid_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsContainer_item">;
  readonly " $fragmentType": "PdpRespSimilarItemsGrid_item";
};
export type PdpRespSimilarItemsGrid_item$key = {
  readonly " $data"?: PdpRespSimilarItemsGrid_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsGrid_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsContainer_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "efbb932a9407ab6f063da060d8201fdd";

export default node;
